import axios from 'axios';
import { handleResponse } from './HelperService';

const getAllBanks = (params, onSuccess, onError) => {
    const response = axios.get('v2/mhc-dealer/dealer-bank', { params });
    return handleResponse(response, onSuccess, onError);
};

const getBank = (id, params, onSuccess, onError) => {
    const response = axios.get(`v2/mhc-dealer/dealer-bank/${id}`,{ params });
    return handleResponse(response, onSuccess, onError);
};

const createBank = (payload, onSuccess, onError) => {
    const response = axios.post(`v2/mhc-dealer/dealer-bank`, payload);
    return handleResponse(response, onSuccess, onError);
};

const updateBank = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v2/mhc-dealer/dealer-bank/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export {getAllBanks, getBank, createBank, updateBank}